import { render, staticRenderFns } from "./header-notifications.vue?vue&type=template&id=42fa3251&scoped=true&"
import script from "./header-notifications.vue?vue&type=script&lang=js&"
export * from "./header-notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fa3251",
  null
  
)

export default component.exports